const article = {
	slug: "leadership-magnified-mentorship",
	title: "Keep Growing and Take Others With You",
	date: "September 2025",
	updated: null,
	description: "A piece of parting advice reframed professional development as a shared journey magnified through mentorship.",
	keywords: ["leadership", "mentorship", "community", "growth"],
	tldr: "Our own success is magnified by the growth we help create in the people around us. Leadership is meeting people where they are and building their confidence to go further.",
	readingTime: null,
	provenance: "Adapted from my LinkedIn post, September 2025.",
	provenanceUrl: null,
	series: null,
	artifact: null,
	markdown: `"Keep growing and take others with you, Swapnil."

That was the parting advice Daleep Singh gave me recently, after an evening celebrating leaders who were being honored for their impact.

Those words perfectly summarized the evening. It was a celebration of leaders with a wider definition of success: building great companies while building up people and community.

Our conversation ranged from my AI projects to his strategic and executive insights. His accomplishments were impressive. But his humility and generosity stood out even more.

I am already seeing his principle in action. I taught my mom Gemini AI recently. She went from hesitant to power user.

That transformation reminded me: leadership is about meeting people where they are and building their confidence to go further.

That parting message is both a challenge and a compass. It reframes professional development as a shared journey. Our own success is magnified by the growth we create in our teams.

My sincere thanks to Daleep and his team for a memorable evening and his candor. And thank you to Prudential and PGIM for creating a culture where leaders are celebrated, and are actively investing in the next generation. It was a powerful, firsthand look at the impact of role models.

It left me grateful for spaces and organizations dedicated to inspiring across generations, and helping people ascend.`,
};

export default article;
